import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogouiComponent } from './logo-ui.component';



@NgModule({
  declarations: [LogouiComponent],
  imports: [
    CommonModule
  ],
  exports:[LogouiComponent]
})
export class LogouiModule { }
